import { useCallback, useState } from "react";

export const useSelection = () => {
  const [selected, setSelected] = useState([]);
  const toggle = useCallback((id, on) => setSelected(list => on ? [...list, id] : list.filter(x => x !== id)), []);
  const replace = useCallback(ids => setSelected(ids), []);
  const clear = useCallback(() => setSelected([]), []);
  return { selected, toggle, replace, clear };
};
